















































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import ModuleCard from '@/components/Modules/ModuleCard.vue';
import CreateModuleDialog from '@/components/Dialogues/CreateModuleDialog.vue';
import { Module } from '@/types';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import env from '../env';

@Component({
  components: { CreateModuleDialog, ModuleCard }
})
export default class ModulesListView extends Vue {
  dialog = false;

  private modules: Array<object> = [];

  private filter: { archived: boolean; cutoverplans: number[] } = {
    archived: false,
    cutoverplans: []
  };

  @Watch('filter.archived')
  watchFilterArchived() {
    this.refreshBlueprintList();
  }

  @Watch('filter.cutoverplans')
  watchFilterCutoverplans() {
    this.refreshBlueprintList();
  }

  async refreshBlueprintList() {
    const { data: blueprints } = await axios.get(`${env.backend_url}/module/blueprints/all`, {
      params: this.filter
    });
    this.modules = blueprints;
  }

  async created() {
    this.$emit('showPreloader');
    await this.refreshBlueprintList();
    this.$emit('loadingFinished');
  }

  async cloneBlueprint(blueprint: Module) {
    const { data: newBlueprint } = await axios.post(`${env.backend_url}/module/clone`, blueprint);

    this.$store.commit('addModuleToModuleIdsToNameMap', {
      id: newBlueprint.id,
      name: newBlueprint.name
    });
    await this.$router.push({
      path: `/blueprints/${newBlueprint.id}`
    });
  }

  async archiveBlueprint(blueprint: Module) {
    await axios.post(`${env.backend_url}/module/archive/${blueprint.id}`);
    await this.refreshBlueprintList();
  }
}
